import { render, staticRenderFns } from "./AppItemImageSelector.vue?vue&type=template&id=39e6fe6a&scoped=true&"
import script from "./AppItemImageSelector.vue?vue&type=script&lang=ts&"
export * from "./AppItemImageSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppItemImageSelector.vue?vue&type=style&index=0&id=39e6fe6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e6fe6a",
  null
  
)

export default component.exports